import { render } from "./CatSocioNegocioForm.vue?vue&type=template&id=57496999&scoped=true"
import script from "./CatSocioNegocioForm.vue?vue&type=script&lang=js"
export * from "./CatSocioNegocioForm.vue?vue&type=script&lang=js"

import "./CatSocioNegocioForm.vue?vue&type=style&index=0&id=57496999&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-57496999"]])

export default __exports__